'use client';
import styled from 'styled-components';

export const StyledQuizCallout = styled.div`
  box-sizing: border-box;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  border-radius: ${props => props.$borderRadius};
  padding: ${props => props.theme.spacing(4)};
  width: 100%;
  max-width: 345px;
  min-height: ${props => props.$minHeight || 'auto'};
  display: ${props => (props.$hideCallout ? 'none' : 'flex')};
  gap: ${props => props.theme.spacing(4)};
  text-align: left;
  align-items: center;
  margin: ${props => props.theme.spacing(...props.$margin)};

  @media ${props => props.theme.laptop} {
    display: flex;
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Headline = styled.p`
  ${props => props.theme.typography.bodyBold};
`;

export const Subheadline = styled.p`
  ${props => props.theme.typography.body};
  ${props =>
    props.$usePrimaryText &&
    `color: ${props.theme.colors.get('text.primary')};`}
`;

export const Attribute = styled.p`
  ${props => props.theme.typography.label};
  color: ${props => props.theme.colors.text.primary};
`;
